$(function() {
  var splide = new Splide( '.splide');
  splide.mount();

  var mediaSets = $(`.product__image-container .product__primary-image-wrapper .product__media`);
  var firstSet = mediaSets.first().data('image-id');
  $('.product__image-container .product__primary-image-wrapper').data('product-initial-image', firstSet);
  $('.splide__arrow--prev').prop('disabled', true).prop('aria-disabled', true);

  $('[data-product-swatch]').click(function() {
    $('.splide__arrow--prev').prop('disabled', true).prop('aria-disabled', true);
    $('.splide__arrow--next').prop('disabled', false).prop('aria-disabled', false);
  });
  
  $(document).on('click', '.product__image-container .product__primary-image-wrapper .splide__arrows .splide__arrow', function (e) {

    console.log(e);
    
    if ($(this).hasClass('splide__arrow--next')) {
      hideActiveImage('next');
    } else if ($(this).hasClass('splide__arrow--prev')) { 
      hideActiveImage('prev');
    }
  });

  $(document).on('click', '.product__image-container .product_thumbnail-list .product_thumbnail button', function (e) {
    var imageId = e.currentTarget.dataset.thumbnailId;
    $('.product__image-container .product__primary-image-wrapper').data('product-initial-image', imageId);
  });
  
  function hideActiveImage(arrow) {
    var imageId = $('.product__image-container .product__primary-image-wrapper').data('product-initial-image');
    var mediaSets = $(`.product__image-container .product__primary-image-wrapper .product__media`);
    var media = $(`.product__image-container .product__primary-image-wrapper .product__media[data-image-id='${imageId}']`);
    var nextImageId = $(media).next().data('image-id');
    var prevImageId = $(media).prev().data('image-id');
    var initialImageId = "";
    
    $(media).addClass('hide');
    if (arrow == "next") {
      $(media).next().removeClass('hide');
      initialImageId = nextImageId;
    } else if (arrow == "prev") {
      $(media).prev().removeClass('hide');
      initialImageId = prevImageId;
    }

    if (initialImageId == mediaSets.first().data('image-id')) {
      $('.splide__arrow--prev').prop('disabled', true).prop('aria-disabled', true);
    } else {
      $('.splide__arrow--prev').prop('disabled', false).prop('aria-disabled', false);
    }

    if (initialImageId == mediaSets.last().data('image-id')) {
      $('.splide__arrow--next').prop('disabled', true).prop('aria-disabled', true);
    } else {
      $('.splide__arrow--next').prop('disabled', false).prop('aria-disabled', false);
    }
    
     $('.product__image-container .product__primary-image-wrapper').data('product-initial-image', initialImageId);
  }
  
  $('.metafield-rich_text_field p:contains("[powered-by-nova]")').parent().append("<p class='powered-by-p'>Powered by <a href='/pages/nova-insole-technology'>NOVA Insole Technology.</a></p>");
  $('.metafield-rich_text_field p:contains("[powered-by-nova]")').each(function() {
    var parentHtml = $(this).parent().html();
    $(this).parent().html(parentHtml.replace('[powered-by-nova]', ''));
  });

});

jQuery(function($){
    $(document).ready(function() {
      // Function to check if the button should be shown
      function checkScrollPosition() {
        var scrollPosition = $(window).scrollTop();
        var specificPoint = 1000; // Adjust this value as needed
    
        if (scrollPosition > specificPoint) {
          $('.add-btn-anchor-mob').fadeIn();
        } else {
          $('.add-btn-anchor-mob').fadeOut();
        }
      }
    
      // Check on initial load
      checkScrollPosition();
    
      // Check on scroll
      $(window).scroll(function() {
        checkScrollPosition();
      });
    });
if (document.referrer.indexOf('index') !== -1) {
  // The referrer is the index page
  console.log('User came from the index page');
} else {
  // The referrer is not the index page
  console.log('User did not come from the index page');
}

setTimeout(function() {
 
const classes1 = ['Heels', 'Flats', 'Wedges', 'Loafers', 'Mules', 'Mary'];
const classes2 = ['Open Toes', 'Strap'];
const classes3 = ['Btl365', 'Medical'];
const classes4 = ['Shoe', 'Foot', 'Socks', 'Handsocks', 'Bags', 'Scrunchies', 'Gift Cards'];
const classes5 = ['Boys', 'Girls'];
const classes6 = ['Special', 'Save'];
const classes7 = ['New'];

let hasClass1 = false;
$.each(classes1, function(index, className1) {
  if ($('#dynamic-breadcrumb a').hasClass(className1)) {
    hasClass1 = true;
    return false; // exit the loop
  }
});
let hasClass2 = false;
$.each(classes2, function(index, className2) {
  if ($('#dynamic-breadcrumb a').hasClass(className2)) {
    hasClass2 = true;
    return false; // exit the loop
  }
});
let hasClass3 = false;
$.each(classes3, function(index, className3) {
  if ($('#dynamic-breadcrumb a').hasClass(className3)) {
    hasClass3 = true;
    return false; // exit the loop
  }
});
let hasClass4 = false;
$.each(classes4, function(index, className4) {
  if ($('#dynamic-breadcrumb a').hasClass(className4)) {
    hasClass4 = true;
    return false; // exit the loop
  }
});
let hasClass5 = false;
$.each(classes5, function(index, className5) {
  if ($('#dynamic-breadcrumb a').hasClass(className5)) {
    hasClass5 = true;
    return false; // exit the loop
  }
});
let hasClass6 = false;
$.each(classes6, function(index, className6) {
  if ($('#dynamic-breadcrumb a').hasClass(className6)) {
    hasClass6 = true;
    return false; // exit the loop
  }
});
let hasClass7 = false;
$.each(classes7, function(index, className7) {
  if ($('#dynamic-breadcrumb a').hasClass(className7)) {
    hasClass7 = true;
    return false; // exit the loop
  }
});

if (hasClass1) {
 var breadcrumbHTML = ` <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="Women">Women</span>
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <a href="/collections/shoes" class="All Shoes">All Shoes</a>
   `;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);
}

if(hasClass2){
var breadcrumbHTML = ` <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="Women">Women</span>
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <a href="/collections/sandals" class="All Sandals">All Sandals</a>`;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);

}
if(hasClass3){
var breadcrumbHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="Women">Women</span>
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="collections">Collections</span>
    `;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);

}
if(hasClass4){
var breadcrumbHTML = ` <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <a href="/collections/accessories" class="Accessories">All Accessories</a>`;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);

}
if(hasClass5){
var breadcrumbHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="Kids">Kids</span>`;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);

}
if(hasClass6){
var breadcrumbHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="Sale">Sale</span>`;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);

}
if(hasClass7){
var breadcrumbHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <span class="New In">New In</span>`;
$('#dynamic-breadcrumb').prepend(breadcrumbHTML);

}

}, 2000);


});


// // force script ios = instant, android = smooth scroll //
// jQuery(function($){
//   // Sticky button fade in/out
//   function checkScrollPosition() {
//     var scrollPosition = $(window).scrollTop();
//     var specificPoint = 1000; // adjust as needed

//     if (scrollPosition > specificPoint) {
//       $('.add-btn-anchor-mob').fadeIn();
//     } else {
//       $('.add-btn-anchor-mob').fadeOut();
//     }
//   }

//   // Initial check
//   checkScrollPosition();

//   // On scroll
//   $(window).on('scroll', checkScrollPosition);

//   // Detect iOS
//   function isIOS() {
//     return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//   }

//   // Click behavior
//   $('.add-btn-anchor-mob').on('click', function(e){
//     e.preventDefault();

//     var target = $('#choose-option');
//     if(target.length){
//       var top = target.offset().top;

//       if (isIOS()) {
//         // iOS = direct instant jump (no smooth scrolling effect)
//         window.scrollTo(0, top);
//       } else {
//         // Android = smooth scroll
//         $('html, body').animate({ scrollTop: top }, 600);
//       }
//     }
//   });
// });
















/*ERGORELIEF PAGE*/
// let panels = gsap.utils.toArray(".slider_card__content");

// panels.forEach((item, i) => {
//   // Get the to be staggered elements
//   const contentElements = item.querySelectorAll(".slider_card__inner > *");

//   // Set initial state on the to be staggered elements
//   gsap.set(contentElements, {
//     opacity: 0
//   });

//   ScrollTrigger.create({
//     trigger: item,
//     //markers: true,
    
//     pin: true,
//     start: "top 50%",
//     end: "bottom 50%",
    
//     snap: { snapTo: [0.5], duration: 1, delay: 0},
    
//     onEnter: ({ progress, direction, isActive }) => {
//       console.log("onEnter", progress, direction, isActive);
//       gsap.fromTo(contentElements, { opacity: 0 }, { opacity: 1, stagger: 0.5 });
//     },
//     onLeave: ({ progress, direction, isActive }) => {
//       console.log("onLeave", progress, direction, isActive);
//       gsap.fromTo(contentElements, { opacity: 1 }, { opacity: 0, stagger: 0.5 });
//     },
//     onLeaveBack: ({ progress, direction, isActive }) => {
//       console.log("onLeaveBack", progress, direction, isActive);      
//       gsap.fromTo(contentElements, { opacity: 1 }, { opacity: 0, stagger: 0.5 });
//     },
//     onEnterBack: ({ progress, direction, isActive }) => {
//       console.log("onEnterBack", progress, direction, isActive);
//       gsap.fromTo(contentElements, { opacity: 0 }, { opacity: 1, stagger: 0.5 });
//     }
//   });
// });

//BREADCRUMB
document.addEventListener('DOMContentLoaded', function() {
  var breadcrumbContainer = document.getElementById('dynamic-breadcrumb');
  var collectionGridLink = document.querySelector('.collection-grid');
  var referrer = document.referrer;

  // Function to update breadcrumb and collection grid link
  function updateBreadcrumb(collectionHandle, collectionTitle, collectionUrl) {

    var breadcrumbHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
      </svg>
      <a href="/collections/${collectionHandle}" class="${collectionTitle}">${collectionTitle}</a>
    `;
    localStorage.setItem('breadcrumb', breadcrumbHTML);
    breadcrumbContainer.innerHTML = breadcrumbHTML;
    if (collectionGridLink) {
      collectionGridLink.href = collectionUrl;
    }
  
}
  // Function to get collection title
  function getCollectionTitle(handle) {
    return handle.replace(/-/g, ' ').replace(/\b\w/g, function(l){ return l.toUpperCase(); });
  }

  // Check if there is a breadcrumb in local storage
  var storedBreadcrumb = localStorage.getItem('breadcrumb');

  // Check if referrer is from a collection page
  if (referrer) {
    var referrerUrl = new URL(referrer);
    var pathArray = referrerUrl.pathname.split('/').filter(function(el) { return el.length != 0 });

    if (pathArray.includes('collections')) {
      var collectionIndex = pathArray.indexOf('collections');
      var collectionHandle = pathArray[collectionIndex + 1];

      if (collectionHandle) {
        var collectionTitle = getCollectionTitle(collectionHandle);
        var collectionUrl = `/collections/${collectionHandle}`;
        updateBreadcrumb(collectionHandle, collectionTitle, collectionUrl);
      }
    }
  }

  // Check if current URL is a collection page and update breadcrumb if necessary
  var currentUrl = new URL(window.location.href);
  var currentPathArray = currentUrl.pathname.split('/').filter(function(el) { return el.length != 0 });

  if (currentPathArray.includes('collections')) {
    var collectionIndex = currentPathArray.indexOf('collections');
    var collectionHandle = currentPathArray[collectionIndex + 1];

    if (collectionHandle) {
      var collectionTitle = getCollectionTitle(collectionHandle);
      var collectionUrl = `/collections/${collectionHandle}`;
      updateBreadcrumb(collectionHandle, collectionTitle, collectionUrl);
    }
  }

  // Load stored breadcrumb if it exists
  if (storedBreadcrumb) {
    breadcrumbContainer.innerHTML = storedBreadcrumb;
    if (collectionGridLink) {
      collectionGridLink.href = storedBreadcrumb.match(/href="([^"]*)"/)[1];
    }
  }

  // Add event listeners to the next and previous product icons
  document.querySelectorAll('.next-prev-icon').forEach(function(icon) {
    icon.addEventListener('click', function() {
      localStorage.setItem('breadcrumb', breadcrumbContainer.innerHTML);
    });
  });
});

